import React from 'react';
import './privacy.css';

function PrivacyAndPolicies() {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>
      <p>
        At Diyatharippu International Optometric Conference, we are committed to protecting the privacy and security of our customers' personal information. This Privacy Policy outlines how we collect, use, and safeguard your information when you visit or make a purchase on our website. By using our website, you consent to the practices described in this policy.
      </p>
      <div className="privacy-policy-section">
        <h2>Information We Collect</h2>
        <ul>
          <li>Personal identification information (such as name, email address, and phone number) provided during registration or checkout.</li>
          <li>Payment and billing information necessary to process orders, securely handled by third-party payment processors.</li>
          <li>Browsing information, such as IP address, browser type, and device details, collected automatically via cookies.</li>
        </ul>
      </div>
      <div className="privacy-policy-section">
        <h2>Use of Information</h2>
        <ul>
          <li>To process and fulfill orders, including shipping and delivery.</li>
          <li>To communicate about purchases, provide customer support, and respond to inquiries.</li>
          <li>To personalize shopping experiences and provide relevant promotions.</li>
          <li>To improve our website, products, and services based on feedback and browsing patterns.</li>
          <li>To detect and prevent fraud and unauthorized activities.</li>
        </ul>
      </div>
      <div className="privacy-policy-section">
        <h2>Information Sharing</h2>
        <p>
          We do not sell, trade, or transfer personal information without consent, except:
        </p>
        <ul>
          <li>With trusted service providers assisting in website operations, payment processing, and product delivery.</li>
          <li>When required by law or in response to legal requests.</li>
        </ul>
      </div>
      <div className="privacy-policy-section">
        <h2>Data Security</h2>
        <p>
          We implement industry-standard security measures to protect personal information. However, no method of transmission or storage is 100% secure.
        </p>
      </div>
      <div className="privacy-policy-section">
        <h2>Cookies and Tracking Technologies</h2>
        <p>
          We use cookies to enhance browsing, analyze traffic, and personalize experiences. Users can disable cookies in their browser settings.
        </p>
      </div>
      <div className="privacy-policy-section">
        <h2>Changes to the Privacy Policy</h2>
        <p>
          We reserve the right to update this Privacy Policy. Changes will be posted with a revised "last updated" date.
        </p>
      </div>
      <div className="privacy-policy-section privacy-contact-section">
        <h2>Contact Us</h2>
        <p>
          For questions or concerns, contact our customer support team.
        </p>
      </div>
    </div>
  );
}

export default PrivacyAndPolicies;
